import React from "react";
import { Button, Image } from "react-bootstrap";
import "./ButtonSocial.css"

export const ButtonSocial = ({variant = "instagram", url}) => {

  const openInNewTab = urlString => {
    window.open(urlString, '_blank');
  };

  return (
    <Button style={{justifyContent: 'center', position: 'relative'}} onClick={()=> openInNewTab(url)} className={variant}>
      {
        variant !== "" &&
        <div style={{textAlign: 'initial', width: "35%", position: 'absolute', left: '14px'}}>
          <Image src={require(`../../../Images/${variant}.svg`)} width={25}/>
        </div>
      }
      <span>
        {variant === "meeting" ? "Agendar" : variant === "linkedin" ? "LinkedIn" : variant}
      </span>
    </Button>
  )
}